/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { STATUS } from 'sarsaparilla';

import {
    FETCH_TOUR_AVAILABILITY_SUCCESS,
    FETCH_TOUR_AVAILABILITY_ERROR,
    SET_FETCH_TOUR_AVAILABILITY_STATUS,
    RESET_TOUR_AVAILABILITY,
    FETCH_FARTHEST_AVAILABILITY_SUCCESS,
} from '../actions/tourAvailabilityActions';

export const initialState = {
    tourId: null,
    loadingStatus: STATUS.IDLE,
    lastFetched: {},
    isAvailableByDate: {},
    isSoldOutByDate: {},
    isFirstComeFirstServedByDate: {},
    isNotReleasedByDate: {},
    availableTourIdsByDate: {},
    error: null,
    lastFetchedAccountType: '',
    nextReleaseByDate: {},
    farthestAvailability: {
        lastFetched: null,
        farthestByTour: {},
    },
};

export const tourAvailabilityReducers = (state = initialState, action) => {
    switch (action.type) {
        case SET_FETCH_TOUR_AVAILABILITY_STATUS:
            return {
                ...state,
                loadingStatus: action.payload,
            };
        case FETCH_TOUR_AVAILABILITY_SUCCESS:
            return {
                ...state,
                ...action.payload,
                nextReleaseByDate: {
                    ...state.nextReleaseByDate,
                    ...action.payload.nextReleaseByDate,
                },
                isLoading: false,
                loadingStatus: STATUS.SUCCESS,
                error: null,
            };
        case FETCH_TOUR_AVAILABILITY_ERROR:
            return {
                ...state,
                error: action.payload,
                isLoading: false,
                loadingStatus: STATUS.ERROR,
            };
        case FETCH_FARTHEST_AVAILABILITY_SUCCESS:
            return {
                ...state,
                farthestAvailability: {
                    farthestByTour: action.payload.farthestByTour,
                    lastFetched: action.payload.lastFetched,
                },
                isLoading: false,
                loadingStatus: STATUS.SUCCESS,
                error: null,
            };
        case RESET_TOUR_AVAILABILITY:
            return initialState;
        default:
            return state;
    }
};
